import useLocale from 'next-translate/useTranslation';
import React from 'react';

import BarwenockLogo from '~/svg/Barwenock.svg';
import BengsLogo from '~/svg/Bengs.svg';
import OktaLogo from '~/svg/Okta.svg';
import StripeLogo from '~/svg/Stripe.svg';
import SupabaseLogo from '~/svg/Supabase.svg';
import TailwindLogo from '~/svg/Tailwind.svg';
import TypescriptLogo from '~/svg/Typescript.svg';
import LalamoveLogo from '~/svg/Lalamove.svg';

const logos = [
  {
    component: <LalamoveLogo className='h-24 w-auto dark:fill-white' />,
    url: 'https://nextjs.org/',
  },
  {
    component: <StripeLogo className='h-16  w-auto' />,
    url: 'https://stripe.com/',
  },
  {
    component: <TailwindLogo className='h-16 w-auto dark:fill-white' />,
    url: 'https://tailwindcss.com/',
  },
  {
    component: <TypescriptLogo className='h-24 w-auto dark:fill-white' />,
    url: 'https://www.typescriptlang.org/',
  },
  {
    component: <SupabaseLogo className='w-auto h-20 dark:fill-white' />,
    url: 'https://supabase.com/',
  },

  {
    component: <BengsLogo className='h-24 w-auto' />,
    url: 'https://www.typescriptlang.org/',
  },
  {
    component: <BarwenockLogo className=' h-12 w-auto' />,
    url: 'https://nextjs.org/',
  },
  {
    component: <OktaLogo className='h-24 w-auto dark:fill-white' />,
    url: 'https://www.typescriptlang.org/',
  },
];

const LogosCloudLogin = ({ hideManyMode = false }) => {
  const { t } = useLocale('login');

  return (
    <div className='w-full max-w-3xl mx-auto mt-8'>
      <div className='grid grid-cols-3 lg:grid-cols-4 items-center content-center	 gap-2 w-full'>
        {logos.map((logo, index) => {
          return (
            <div key={index} className='text-center flex justify-center'>
              {logo.component}
            </div>
          );
        })}
      </div>
      {!hideManyMode && (
        <div className='mt-6 text-xs text-gray-400'>
          {t('And many more...')}
        </div>
      )}
    </div>
  );
};

export default LogosCloudLogin;
